/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  const prefectureOrder = [
    '北海道',
    '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
    '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
    '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
    '岐阜県', '静岡県', '愛知県', '三重県',
    '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
    '鳥取県', '島根県', '岡山県', '広島県', '山口県',
    '徳島県', '香川県', '愛媛県', '高知県',
    '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県',
    '沖縄県'
  ];

  const orderMap = new Map(
    prefectureOrder.map(function (name, index) {
      return [name, index];
    })
  );

  function sortPrefectureSelect(select) {
    if (!select || select.dataset.prefSorted === 'true') return;

    const options = Array.from(select.options);

    const placeholderOptions = options.filter(function (opt) {
      return !opt.value || opt.value === '';
    });

    const prefectureOptions = options.filter(function (opt) {
      return opt.value && orderMap.has(opt.text.trim());
    });

    const otherOptions = options.filter(function (opt) {
      return opt.value && !orderMap.has(opt.text.trim());
    });

    prefectureOptions.sort(function (a, b) {
      return orderMap.get(a.text.trim()) - orderMap.get(b.text.trim());
    });

    const currentValue = select.value;

    select.innerHTML = '';

    placeholderOptions.forEach(function (opt) {
      select.appendChild(opt);
    });

    prefectureOptions.forEach(function (opt) {
      select.appendChild(opt);
    });

    otherOptions.forEach(function (opt) {
      select.appendChild(opt);
    });

    if (currentValue) {
      select.value = currentValue;
    }

    select.dataset.prefSorted = 'true';
  }

  function findJapanPrefectureSelects() {
    const selects = document.querySelectorAll('select');

    selects.forEach(function (select) {
      const optionTexts = Array.from(select.options).map(function (opt) {
        return opt.text.trim();
      });

      const hitCount = prefectureOrder.filter(function (pref) {
        return optionTexts.includes(pref);
      }).length;

      if (hitCount >= 10) {
        sortPrefectureSelect(select);
      }
    });
  }

  findJapanPrefectureSelects();

  const observer = new MutationObserver(function () {
    findJapanPrefectureSelects();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/**
 * コレクションページのフィルターから、お客様に見せる必要のない内部用タグを非表示にする
 * （タグ自体は削除・変更しない。表示だけを隠す）
 * 対象: rakuten- で始まるタグ / wrapped:blocks:hide: で始まるタグ
 */
document.addEventListener('DOMContentLoaded', function () {
  var hiddenTagPrefixes = ['rakuten-', 'wrapped-blocks-hide-'];

  var buttons = document.querySelectorAll('.CollectionFilters [data-action="toggle-tag"][data-tag]');

  Array.prototype.forEach.call(buttons, function (button) {
    var tag = button.getAttribute('data-tag') || '';

    var shouldHide = hiddenTagPrefixes.some(function (prefix) {
      return tag.indexOf(prefix) === 0;
    });

    if (shouldHide) {
      var item = button.closest('li') || button;
      item.style.display = 'none';
    }
  });
});